"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _breadcrumb = _interopRequireDefault(require("@amzn/meridian-tokens/component/breadcrumb"));
var _context = _interopRequireDefault(require("./context"));
var _theme = require("../theme");
var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));
var _functional = require("./../_utils/functional");
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
var styles = (0, _css.css)(_listReset["default"], {
  display: "flex",
  flexDirection: "row",
  alignItems: "center"
});
var getContextValue = (0, _functional.memoizeCurry)(function (t, selected) {
  return {
    t: t,
    selected: selected
  };
}, 1);

/**
 * Used to group a set of breadcrumbs.
 */
function BreadcrumbGroup(props) {
  var t = (0, _theme.useTheme)(_breadcrumb["default"], "breadcrumb");
  var breadcrumbs = _react["default"].Children.toArray(props.children);
  var lastIndex = breadcrumbs.length - 1;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-"]);
  return /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    className: styles
  }, passThroughProps), breadcrumbs.map(function (breadcrumb, index) {
    return /*#__PURE__*/_react["default"].createElement(_context["default"].Provider, {
      key: index,
      value: getContextValue(t)(index === lastIndex)
    }, breadcrumb);
  }));
}
BreadcrumbGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The list of breadcrumbs to display. These must be elements of the
   * `Breadcrumb` component.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string
} : {};
var _default = BreadcrumbGroup;
exports["default"] = _default;